import { Building } from "lucide-react";
import type { FC } from "react";
import { IconProps } from "./types";

export const Companies: FC<IconProps> = ({ size = "1em", ...props }) => (
  <Building width={size} height={size} {...props} />
);
